var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSizemanagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_1468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 23.138C16.7839 23.138 19.0408 20.9101 19.0408 18.1618C19.0408 15.4135 16.7839 13.1855 14 13.1855C11.216 13.1855 8.95911 15.4135 8.95911 18.1618C8.95911 20.9101 11.216 23.138 14 23.138Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6316 3.01908C12.6316 2.27289 13.2443 1.66797 14 1.66797C14.7557 1.66797 15.3684 2.27289 15.3684 3.01908C15.3684 3.76527 14.7557 4.37019 14 4.37019V5.80787",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.278 6.98137L14 5.80762L16.722 6.98137",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71606 19.4135V8.42285",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2838 19.4135V8.42285",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1989 8.99106L16.722 6.98145V7.31406C16.722 8.79811 15.5033 10.0012 14 10.0012C12.4967 10.0012 11.278 8.79811 11.278 7.31406V6.98145L4.80105 8.99106L2.06262 14.1364L6.71611 16.1065V26.3319H21.2838V16.1065L25.9373 13.6351L23.1989 8.99106Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2371 19.7868L12.825 16.5714C12.8396 16.4961 12.946 16.489 12.9707 16.5617L13.9271 19.7618C13.9503 19.8299 14.0481 19.8295 14.0706 19.7611L14.9943 16.5623C15.0183 16.4894 15.1247 16.4953 15.1402 16.5704L15.7629 19.7869",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_1468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 28,
    fill: "white",
    transform: "translate(1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizemanagement);
export default __webpack_public_path__ + "static/media/Sizemanagement.458708693641d9e5354f19c5b62bd49b.svg";
export { ForwardRef as ReactComponent };